import { getConditionalObject } from 'utils/data';

import { ORDER_CONTACTS_GRID_TEMPLATE_COLUMNS } from '../../AppraisalOrderContactsCard.styles';

export const getRowContainerStyles = ({ isLastRow }) => ({
  ...getConditionalObject(!isLastRow, () => ({
    borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  })),
});

export const getRowStyles = ({ isManualEntryOpen }) => ({
  display: 'grid',
  gridTemplateColumns: ORDER_CONTACTS_GRID_TEMPLATE_COLUMNS,
  gap: '16px',
  alignItems: 'center',
  padding: '8px 16px',

  ...getConditionalObject(isManualEntryOpen, () => ({
    backgroundColor: ({ palette }) => palette.background.secondary,
  })),
});

export const roleCellStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '2px',
  minWidth: 0,
};

export const textCellStyles = {
  minWidth: 0,
};

export const descriptionInputStyles = {
  margin: 0,
};

export const missingAgentNoteStyles = {
  gridColumn: '3 / -1',
  marginTop: '-4px',
};
